import { Observable, of } from 'rxjs';
import { AbstractServiceOrganization } from './organization.service.abstract';
import { ModelOrganization } from '../../models/organizations/organization.model';

export class MockServiceOrganization implements AbstractServiceOrganization {
    UpdateOrganizations(organizations: ModelOrganization[]): Observable<string> {
        if (organizations.length > 0) {
            return (of('success'))
        }
        return (of('error'))
    }

}